import React, { useEffect, useState } from 'react'
import './App.css'
import {
  selectLogin,
  closeLogin,
  selectHomePage,
  selectUserInfo,
  openUserInfo,
  selectAdminPage,
  selectCaiwuPage,
  selectSchoolAdminPage
} from './store/modalsSlice'
import { useSelector, useDispatch } from 'react-redux'
import Login from './features/LoginPage/Login'
import { CustomAlert } from './features/CustomView/CustomAlert'
import { selectAlertInfo, setAlertInfo } from './store/CustomViewSlice'
import { Button, ConfigProvider, message, Modal } from 'antd'

import HomePage from './features/HomePage/HomePage'
import locale from 'antd/locale/zh_CN'
import AdminPage from './features/AdminPage/AdminPage'
import CaiwuPage from './features/CaiwuPage/CaiwuPage'
import PlayerModal from './features/PlayerModal/PlayerModal'
import Cookies from 'js-cookie'
import SchoolAdminPage from './features/SchoolAdmin/SchoolAdmin'
function App() {
  // const script = document.createElement('script');
  // script.type = 'text/javascript';
  // script.src  = 'https://spark-gamepku.oss-cn-qingdao.aliyuncs.com/tbi/aliyun-upload-sdk-1.5.7.min.js'
  // script.async = true;
  // document.body.appendChild(script);
  //
  // const script1 = document.createElement('script');
  // script1.type = 'text/javascript';
  // script1.src  = 'https://spark-gamepku.oss-cn-qingdao.aliyuncs.com/tbi/aliyun-oss-sdk-6.17.1.min.js'
  // script1.async = true;
  // document.body.appendChild(script1);

  const dispatch = useDispatch()
  const [messageApi, contextHolder] = message.useMessage()
  const loginVisible = useSelector(selectLogin)
  const HomePageVisible = useSelector(selectHomePage)
  const alertInfo = useSelector(selectAlertInfo)
  const userInfoVisible = useSelector(selectUserInfo)
  const adminPageVisible = useSelector(selectAdminPage)
  const caiwuPageVisible = useSelector(selectCaiwuPage)
  const schoolAdminPageVisible = useSelector(selectSchoolAdminPage)

  useEffect(() => {
    // 在这里执行你的组件挂载后的逻辑
    const showAlert = (e) => {
      // 处理窗口大小变化的逻辑
      dispatch(
        setAlertInfo({
          showPlayerModalStatus: true,
          title: '',
          title1: e.detail.content,
          content: '',
        }),
      )
    }
    window.addEventListener('showCustomAlert', showAlert)

    if (Cookies.get('type') === '99') {
      dispatch(openUserInfo())
      dispatch(closeLogin())
    }

    return () => {
      // 组件卸载前移除事件监听
      window.removeEventListener('showCustomAlert', showAlert)
    }
  }, [])
  return (
    <ConfigProvider
      locale={locale}
      theme={{
        token: {
          colorPrimary: '#2772F0',
          colorBgContainer: '',
          groupTitleFontSize: 28,
        },
        components: {
          Menu: {
            /* 这里是你的组件 token */
            fontSize: 14,
            // activeBarHeight:156,
            itemHeight: 56,
          },
          Button: {
            fontSize: 14,
          },
          Tabs: {
            colorPrimary: '#F5B544',
            itemHoverColor: '#F5B544',
            itemActiveColor: '#F5B544',
            itemSelectedColor: '#F5B544',
            horizontalItemGutter: 80,
          },
          Table: {
            colorPrimary: '#F5B544',
            headerBg: '#F5B544',
            rowHoverBg: '#fef8ed',
          },
          Anchor: {
            colorPrimary: '#F5B544',
            fontSize: 18,
            linkPaddingInlineStart: 40,
          },
          Rate: {
            starColor: '#ec4c08',
            starSize: 18,
          },
          Checkbox: {
            lineHeight: 3,
          },
        },
      }}
    >
      <div className="App">
        {contextHolder}
        <div className="pageContainer">
          {loginVisible ? <Login /> : null}
          {HomePageVisible ? <HomePage /> : null} {/*产品运营功能*/}
          <CustomAlert info={alertInfo} />
          {/*{userInfoVisible ? <userManager/> : null}*/}
          {adminPageVisible ? <AdminPage /> : null}
          {caiwuPageVisible ? <CaiwuPage /> : null}
          {schoolAdminPageVisible ? <SchoolAdminPage /> : null}
        </div>
        <PlayerModal />
      </div>
    </ConfigProvider>
  )
}

export default App
